/**
 * A custom metric sub-metric's valid range (see the API's utils/validRange): values
 * outside it are ignored when scoring, as if there were no value. null = no limit.
 */
export const isOutsideValidRange = (value: number, min?: number | null, max?: number | null): boolean =>
  (min != null && value < min) || (max != null && value > max);

/** "0–100", "≥ 0", "≤ 100"; '' when neither bound is set. */
export const formatValidRange = (min?: number | null, max?: number | null): string => {
  if (min != null && max != null) return `${min}–${max}`;
  if (min != null) return `≥ ${min}`;
  if (max != null) return `≤ ${max}`;
  return '';
};
